<template>
    <div class="quality-knowledge-container">
        <PreLoader v-if="isLoading"/>
        <div class="header-title">
            <h3>{{ $t('knowledgeQualityReport') }}</h3>
        </div>

        <v-form class="select-form select-clear-block" ref="form" style="align-items: flex-start; gap: 8px">
            <v-select :items="instrClasses" item-text="classTitle" :label="$t('class')" :rules="required"
                      class="v-select-item" v-model="reportObj.classObj" :return-object="true"
                      :no-data-text="$t('no_data')" outlined dense/>
            <v-select :items="schoolQuarters" item-text="semester" item-value="id" :label="$t('quarter')"
                      :rules="required" v-model="reportObj.quarterId" class="v-select-item quarter"
                      :no-data-text="$t('no_data')" outlined dense @change="setDataTitle"/>
            <v-btn color="primary" @click="fetchQualityKnowledgeReport" v-text="$t('generate')"/>
        </v-form>

        <div class="report-content" ref="report" v-if="showTable">
            <div class="report-title">
                <h3 v-html="reportTitle"/>
            </div>
            <v-simple-table class="tab-st">
                <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-table" v-html="$t('classes')"/>
                    <th class="text-table" v-html="$t('studentQuantity')"/>
                    <th class="text-table">"5"</th>
                    <th class="text-table">"4"</th>
                    <th class="text-table">"3"</th>
                    <th class="text-table">"2"</th>
                    <th class="text-table" v-html="$t('knowledgeQuality')"/>
                    <th class="text-table" v-html="$t('performance')"/>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{{classReport.classLevel + classReport.classLabel}}</td>
                    <td>{{classReport.totalStudentsCount}}</td>
                    <td>{{classReport.totalFive}}</td>
                    <td>{{classReport.totalFour}}</td>
                    <td>{{classReport.totalThree}}</td>
                    <td>{{classReport.totalTwo}}</td>
                    <td>{{countKnowledgeQuality()}} %</td>
                    <td>{{countPerformance()}} %</td>
                </tr>
                </tbody>
                </template>
            </v-simple-table>
            <div class="btn-block-st">
                <h3 class="director-name" v-html="$t('principal') + ':'"/>
                <v-btn color="primary" @click="exportPdf" v-text="$t('export')"/>
            </div>
        </div>
    </div>
</template>

<script>
import AnalyticsService from '@/_services/analytics.service'
import PreLoader from '@/components/preloader/PreLoader'

export default {
  components: {
    PreLoader
  },
  props: {
    instrClasses: Array,
    allChronicleYears: Array,
    schoolQuarters: Array
  },
  data () {
    return {
      required: [v => !!v || this.$t('required')],
      reportObj: {
        classObj: '',
        quarterId: ''
      },
      showTable: false,
      isLoading: false,
      classReport: {},
      selectedChronicleYear: '',
      selectedClassTotalStudents: '',
      selectedQuarterTitle: ''
    }
  },

  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    reportTitle () {
      if (this.$root.$i18n.locale === 'ru') {
        return 'Отчет <br> по качеству знаний и успеваемости за ' + this.selectedChronicleYear + ', четверть - ' + this.selectedQuarterTitle
      } else {
        return 'Отчет <br>' + this.selectedChronicleYear + ' үчүн билим сапаты жана жетишкендиктери боюнча, ' + this.selectedQuarterTitle +
                  ' - чейрек'
      }
    }
  },

  methods: {
    setDataTitle (quatId) {
      this.selectedQuarterTitle = this.schoolQuarters.find(quat => quat.id === quatId).semester
      this.selectedChronicleYear = this.allChronicleYears.find((item) => item.id === this.school.chronicleId).selectorTitle
      this.showTable = false
    },

    fetchQualityKnowledgeReport () {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        this.showTable = false
        AnalyticsService.getStudentPerformance(
          this.school.id,
          this.school.chronicleId,
          this.reportObj.quarterId,
          this.reportObj.classObj.classId,
          this.reportObj.classObj.courseId
        ).then((res) => {
          if (res.length) {
            this.classReport = res.find((klass) => klass.classId === this.reportObj.classObj.classId)
            AnalyticsService.getTotalStudentsCount(this.school.id, this.reportObj.classObj.classId).then((res) => {
              this.classReport.totalStudentsCount = res[0].totalStudentCount
              this.showTable = true
              this.isLoading = false
            }).catch((err) => {
              this.$toast.error(err)
              this.isLoading = false
            })
          } else {
            this.$toast.info(this.$t('no_data'))
            this.isLoading = false
          }
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    },

    countKnowledgeQuality () {
      const totalGrades = this.classReport.totalFive + this.classReport.totalFour
      const result = (totalGrades / this.classReport.totalStudentsCount) * 100
      return result.toFixed(1)
    },

    countPerformance () {
      const klass = this.classReport
      const totalGoodStudents = klass.totalStudentsCount - klass.totalTwo
      const result = (totalGoodStudents / klass.totalStudentsCount) * 100
      return result.toFixed(1)
    },

    exportPdf () {
      this.$refs.report.style.width = this.setDisplaySize()
      this.$refs.report.style.height = this.setDisplaySize()
      this.$refs.report.querySelector('.report-title').style.width = '1170px'
      const clonedTable = this.$refs.report.cloneNode(true)
      this.synchronizeCssStyles(this.$refs.report, clonedTable, true)
      clonedTable.style.transform = 'rotate(90deg)'
      clonedTable.style.margin = '0'
      const win = window.open('', '')
      win.document.body.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
      win.document.body.innerHTML = (clonedTable.outerHTML)
      win.print()
      win.onafterprint = window.navigator.appVersion.includes('Mac') ? () => win.close() : win.close()
      this.$refs.report.style.width = 'auto'
      this.$refs.report.style.height = 'auto'
      this.$refs.report.querySelector('.report-title').style.width = 'auto'
    },

    synchronizeCssStyles (src, destination, recursively) {
      destination.style.cssText = this.getComputedStyleCssText(src)
      if (recursively) {
        const vSrcElements = src.getElementsByTagName('*')
        const vDstElements = destination.getElementsByTagName('*')
        for (let i = vSrcElements.length; i--;) {
          const vSrcElement = vSrcElements[i]
          const vDstElement = vDstElements[i]
          vDstElement.style.cssText = this.getComputedStyleCssText(vSrcElement)
        }
      }
    },

    getComputedStyleCssText (element) {
      const cssObject = window.getComputedStyle(element)
      const cssAccumulator = []
      if (cssObject.cssText !== '') {
        return cssObject.cssText
      }
      for (const prop in cssObject) {
        if (typeof cssObject[prop] === 'string') {
          cssAccumulator.push(prop + ' : ' + cssObject[prop])
        }
      }
      return cssAccumulator.join('; ')
    },

    setDisplaySize () {
      return window.innerWidth <= 1366 ? '110vh' : '80vh'
    }
  }
}
</script>

<style lang="scss">
.tab-st{
    width: max-content;
    margin: 0 auto;
    //padding-top: 10px;
}
.btn-block-st{
    display: flex;
    flex-direction: row;
    gap: 50px;
    flex-wrap: wrap;
    padding: 20px 0;
    width: max-content;
    align-items: center;
    margin: 0 auto;
}
th, td{
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
}
    .quality-knowledge-container {
        .header-title {
            h3 {
                font-size: 25px;
            }
        }
        .v-select-item {
            &.quarter {
                max-width: 160px;
            }
        }
        .report-content {
            text-align: center;
            margin-top: 25px;
            .report-title {
                text-align: center;
            }
            table.report {
                table-layout: fixed;
                width: 1190px;
                margin: 25px auto;
                th, td {
                    padding: 0 8px;
                }
                th {
                    color: #f84c4c;
                    padding: 0 16px;
                }
                td {
                    font-weight: bold;
                    height: 30px;
                }
            }
        }

        .print-btn {
            width: 1190px;
            margin: 30px auto;
            text-align: right;
            .v-btn:not(.v-btn--round).v-size--default {
                height: 30px;
                padding: 0 10px;
            }
            .v-btn__content {
                font-size: 12px;
            }
        }
    }
</style>
